// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__NrFq8","skeleton-animation":"styles_skeleton-animation__oaFo5","text":"styles_text__1L0zA"};